import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './Image.scss';

import {
  RATIO_1_1,
  WIDTH_400,
} from '../../constants/imageServiceConstants';

export const constructUrl = (
  baseUrl,
  venueId,
  imageId,
  ratio,
  width
) => `${baseUrl}3/003/1/${venueId}/${imageId}/jpg/${ratio}/${width}`;

const Image = React.forwardRef(
  ({
    className,
    // demo and staging: https://image.staging.resy.com/
    // prod: https://image.resy.com/
    baseUrl,
    imageId,
    // the width of the original updloaded image
    originalWidth,
    // desired ratio. one of the available rations from the image service
    ratio,
    // if src is passed in, url is NOT constructed from props
    src,
    venueId,
    // desired width. one of the widgets available from the image service
    width,
    ...props
  },
  /* eslint-disable-next-line no-unused-vars */
  ref) => {
    if (
      originalWidth
      && width > originalWidth
    ) {
      return null;
    }

    const style = {
      backgroundImage: (src && `url(${src})`) || `url(${constructUrl(baseUrl, venueId, imageId, ratio, width)})`,
      // preventing images retrieved by the image service from displayig at larger than source
      maxWidth: src ? null : `${width}px`,
    };

    const classes = cx(className, 'Image');

    return (
      <div className={classes} style={style} {...props} />
    );
  }
);

Image.propTypes = {
  className: PropTypes.string,
  baseUrl: PropTypes.string,
  imageId: PropTypes.string,
  originalWidth: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  ratio: PropTypes.string,
  src: PropTypes.string,
  venueId: PropTypes.string,
  width: PropTypes.string,
};

Image.defaultProps = {
  className: undefined,
  baseUrl: 'https://image.resy.com/',
  imageId: undefined,
  originalWidth: undefined,
  ratio: RATIO_1_1,
  src: undefined,
  venueId: undefined,
  width: WIDTH_400,
};

export default Image;
